import { useDeployment } from "@/lib/DeploymentContext";

const images = [
  {
    src: "https://images.unsplash.com/photo-1609253925210-c64083102ae5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Diverse family outdoors",
    caption: "A family on the path through college and training.",
  },
  {
    src: "https://images.unsplash.com/photo-1611516818236-8faa056fb659?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Latino family in their neighborhood",
    caption: "Two generations under one roof — served together.",
  },
  {
    src: "https://images.unsplash.com/photo-1668701065787-2605db5e4938?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Senior women smiling together",
    caption: "Aging in place, never in isolation.",
  },
  {
    src: "https://images.unsplash.com/photo-1545167622-3a6ac756afa4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Mother and child reading at home",
    caption: "Head Start enrollment + after-school placement.",
  },
  {
    src: "https://images.unsplash.com/photo-1581579438747-104c53e7f126?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Black family on a Houston-area porch",
    caption: "Stable lease. Predictable income. Growing family.",
  },
  {
    src: "https://images.unsplash.com/photo-1504004030892-d06adf9ffbcf?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Senior men gathered together",
    caption: "Weekly connection. Faith, friendship, and rides to the clinic.",
  },
];

export default function ImageGallery() {
  const d = useDeployment();
  return (
    <section
      id="gallery"
      data-testid="section-gallery"
      className="bg-white py-24 lg:py-32 border-y border-[#CBD5E1]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#8B0000]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#8B0000]">
                07 — Who We Serve
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              {d.galleryHeadline}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-2">
            <p className="text-[#334155] leading-relaxed">
              {d.galleryLead}
            </p>
          </div>
        </div>

        {/* Editorial bento grid */}
        <div className="grid grid-cols-12 gap-3 lg:gap-4">
          <Tile caption={d.galleryCaption} className="col-span-12 md:col-span-7 aspect-[4/3]" img={images[0]} />
          <Tile caption={d.galleryCaption} className="col-span-12 md:col-span-5 aspect-[4/3]" img={images[1]} />
          <Tile caption={d.galleryCaption} className="col-span-6 md:col-span-4 aspect-square" img={images[2]} />
          <Tile caption={d.galleryCaption} className="col-span-6 md:col-span-4 aspect-square" img={images[3]} />
          <Tile caption={d.galleryCaption} className="col-span-12 md:col-span-4 aspect-square" img={images[4]} />
          <Tile caption={d.galleryCaption} className="col-span-12 aspect-[21/9]" img={images[5]} />
        </div>
      </div>
    </section>
  );
}

function Tile({ img, className, caption }) {
  return (
    <figure className={`relative overflow-hidden group border border-[#CBD5E1] ${className}`}>
      <img
        src={img.src}
        alt={img.alt}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A192F] to-transparent pt-12 pb-4 px-5">
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#D4AF37]">
          {caption}
        </span>
        <p className="font-display text-base lg:text-lg text-[#F9F7F1] mt-1 leading-snug">
          {img.caption}
        </p>
      </figcaption>
    </figure>
  );
}
